import { render, staticRenderFns } from "./DocumentPreviewExpired.vue?vue&type=template&id=ddd35ba8&scoped=true"
import script from "./DocumentPreviewExpired.vue?vue&type=script&lang=js"
export * from "./DocumentPreviewExpired.vue?vue&type=script&lang=js"
import style0 from "./DocumentPreviewExpired.vue?vue&type=style&index=0&id=ddd35ba8&prod&lang=scss&scoped=true"
import style1 from "./DocumentPreviewExpired.vue?vue&type=style&index=1&id=ddd35ba8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd35ba8",
  null
  
)

export default component.exports